import Entity from "@/services/westore/entities/entity";


class SupportTicket extends Entity {
    static uri = '/support_tickets';
    static statuses = {
        opened: 1,
        closed:2,
    };
    static urgency = {
        high: 1,
        normal:2,
        low:3,
    };

    static store(payloadRequest) {
        return super.create(SupportTicket.uri, payloadRequest)
    }

    static getOne(id, params = {}) {
        return super.get(SupportTicket.uri, id, params)
    }

    static getAll(params = {}) {
        return super.getAll(SupportTicket.uri, params)
    }

    static export(type = 'xlsx', filter) {
        const endpoint = `${SupportTicket.uri}/export?type=${type}`;
        return super.get(endpoint, null, filter);
    }
}

export default SupportTicket;